<template>
  <div class="pa-4">
    <!-- Compact Header -->
    
    <!-- Compact Search Section -->
    <v-card class="mb-4 mt-5" elevation="1">
      <v-card-text class="pa-4">
        <div class="d-flex align-center mb-4">
          <v-avatar color="primary" size="32" class="mr-2">
            <v-icon color="white" size="18">mdi-truck-delivery</v-icon>
          </v-avatar>
          <div>
            <h1 class="text-h6 font-weight-bold primary--text mb-0">Tracking Order</h1>
            <p class="text-caption grey--text mb-0">Lacak status dan dokumen order Anda</p>
          </div>
        </div>
        <v-row align="center" no-gutters>
          <v-col cols="12" md="12" class="px-3">
                         <div class="mb-2">
               <p class="text-subtitle-1 font-weight-bold mb-0">Cari Order</p>
               <p class="text-caption grey--text mb-0">Ketik minimal 2 karakter untuk mencari</p>
             </div>
            <v-autocomplete
              filled
              dense
              solo
              color="#718EBF"
              placeholder="Ketik nomor order untuk mencari..."
              v-on:change="handleOrderChange"
              clearable
              @click:clear="clearFilter"
              :items="order_list"
              item-value="number"
              item-text="number"
              :item-color="set_color"
              v-model="soNumber"
              :error-messages="errors"
              prepend-inner-icon="mdi-format-list-bulleted"
              :loading="process.search"
              :search-input.sync="searchInput"
              @update:search-input="onSearchInput"
              no-data-text="Ketik untuk mencari order..."
              required
              style="border-radius: 8px;"
              class="mr-md-2 mb-2 mb-md-0"
            />
          </v-col>
          <!-- <v-col cols="6" md="2">
            <v-btn
              color="primary"
              @click="searchTracking"
              :loading="loading"
              block
              :disabled="!soNumber"
              elevation="1"
              class="mr-md-2 mb-2 mb-md-0"
            >
              <v-icon left small>mdi-magnify</v-icon>
              Cari
            </v-btn>
          </v-col>
          <v-col cols="6" md="3">
            <v-btn
              color="grey"
              @click="clearFilter"
              outlined
              block
              :disabled="!soNumber"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Reset
            </v-btn>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>
  
    <!-- Empty State -->
    <v-card v-if="!soNumber && !trackingData.length && !loading" class="mb-4" elevation="1">
      <v-card-text class="text-center pa-6">
        <v-icon size="60" color="grey lighten-1" class="mb-3">mdi-magnify</v-icon>
        <h3 class="text-subtitle-1 font-weight-medium grey--text text--darken-1 mb-2">
          Masukkan Nomor SO
        </h3>
        <p class="text-body-2 grey--text">
          Silakan masukkan nomor Sales Order untuk melihat tracking dan status dokumen
        </p>
      </v-card-text>
    </v-card>

    <!-- Loading State -->
    <v-card v-if="loading" class="mb-4" elevation="1">
      <v-card-text class="text-center pa-8">
        <v-progress-circular
          indeterminate
          color="primary"
          size="40"
          width="3"
        ></v-progress-circular>
        <h3 class="text-subtitle-2 font-weight-medium mt-3 mb-1">Memuat Data Tracking</h3>
        <p class="text-caption grey--text">Sedang mengambil informasi order...</p>
      </v-card-text>
    </v-card>

    <!-- No Data Found -->
    <!-- <v-card v-if="!loading && soNumber && !trackingData.length && searched" class="mb-4" elevation="1">
      <v-card-text class="text-center pa-6">
        <v-icon size="60" color="orange" class="mb-3">mdi-alert-circle-outline</v-icon>
        <h3 class="text-subtitle-1 font-weight-medium mb-2">Data Tidak Ditemukan</h3>
        <p class="text-body-2 grey--text mb-3">
          Tidak ada data tracking ditemukan untuk SO: <strong class="primary--text">{{ soNumber }}</strong>
        </p>
        <v-btn color="primary" outlined @click="clearFilter">
          <v-icon left small>mdi-refresh</v-icon>
          Coba Lagi
        </v-btn>
      </v-card-text>
    </v-card> -->
  
    <!-- Compact Order Information -->
    <v-card v-if="!loading && orderInfo" class="mb-4" elevation="2">
      <v-card-title class="gradient-primary white--text pa-2">
        <div class="d-flex align-center">
          <v-avatar color="white" size="32" class="mr-3">
            <v-icon color="primary" size="16">mdi-file-document-outline</v-icon>
          </v-avatar>
          <div>
            <h2 class="text-subtitle-1 font-weight-bold mb-1">{{ orderInfo.number }}</h2>
            <p class="text-caption mb-0 white--text" style="opacity: 0.9;">Sales Order Details</p>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip 
          :color="getStatusColor(orderInfo.status)" 
          dark 
          small
          class="font-weight-bold text-capitalize"
        >
          <v-icon left x-small>mdi-check-circle</v-icon>
          {{ orderInfo.status }}
        </v-chip>
      </v-card-title>
      
      <v-card-text class="pa-2">
        <v-row>
          <v-col cols="12" md="7">
            <table style="width: auto;" class="mb-2" v-if="orderInfo">
              <tr>
                <td class="fs-12">Nama Toko</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">{{ orderInfo.store_name }}</td>
              </tr>
              <tr>
                <td class="fs-12" style="width: 120px;">Nama Customer</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">
                  <a target="_blank" :href="`/customer/data/detail/${orderInfo.customer_id}`" class="primary--text text-decoration-none">
                    {{ orderInfo.customer_name }}
                  </a>
                </td>
              </tr>
              <tr>
                <td class="fs-12">Kode Outlet</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">{{ orderInfo.customer_code }}</td>
              </tr>
              <tr>
                <td class="fs-12">Alamat Pengiriman</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">{{ orderInfo.shipping_address || 'Alamat tidak tersedia' }}</td>
              </tr>
              <tr v-if="orderInfo.shipping_city">
                <td class="fs-12">Kota/Wilayah</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">
                  {{ orderInfo.shipping_city }}{{ orderInfo.shipping_province ? ', ' + orderInfo.shipping_province : '' }}
                </td>
              </tr>
            </table>
          </v-col>
          <v-col cols="12" md="5">
            <table style="width: auto;" class="mb-2" v-if="orderInfo">
              <tr>
                <td class="fs-12">No. Order</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">{{ orderInfo.number }}</td>
              </tr>
              <tr>
                <td class="fs-12">Tanggal Order</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">{{ formatDate(orderInfo.input_datetime) }}</td>
              </tr>
              <tr>
                <td class="fs-12">Nama Sales</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12">{{ orderInfo.sales_name }}</td>
              </tr>
              <div>
                <v-btn
                  color="primary"
                  elevation="0"
                  class="white--text text-capitalize mx-1 px-0"
                  style="font-weight: 600; border-radius: 6px;"
                  :to="`/approval/order/detail/${orderInfo.id}`"
                  target="_blank"
                >
                  Detail
                </v-btn>
              </div>
              <!-- <tr>
                <td class="fs-12">Total Nominal</td>
                <td style="width: 40px" class="fs-12 text-center pb-2">:</td>
                <td class="text-left font-weight-bold fs-12 success--text">
                  Rp {{ orderInfo.total_nominal | number }}
                  {{ orderInfo.orders_detail }}
                  Rp {{ (((orderInfo.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus*1))), 0))) - (orderInfo.total_discount*1) - orderInfo.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus*1)), 0)) | price }}
                </td>
              </tr> -->
            </table>
            
            <!-- Quick Stats -->
            <div class="mt-3 px-3">
              <v-row dense>
                <v-col cols="4" class="text-center">
                  <div class="stat-mini">
                    <div class="text-caption font-weight-bold">{{ summaryStats.find(s => s.label === 'Total Dokumen')?.count || 0 }}</div>
                    <div class="text-caption grey--text">Dokumen</div>
                  </div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="stat-mini">
                    <div class="text-caption font-weight-bold green--text">{{ summaryStats.find(s => s.label === 'BPB')?.count || 0 }}</div>
                    <div class="text-caption grey--text">BPB</div>
                  </div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="stat-mini">
                    <div class="text-caption font-weight-bold blue--text">{{ summaryStats.find(s => s.label === 'Invoice')?.count || 0 }}</div>
                    <div class="text-caption grey--text">Invoice</div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col cols="12" md="6">
        <!-- Compact Documents Timeline - BPB -->
        <v-card v-if="!loading && bpbData.length" class="mb-4" elevation="2">
          <v-card-title class="gradient-success white--text pa-4">
            <div class="d-flex align-center">
              <v-avatar color="white" size="32" class="mr-3">
                <v-icon color="green" size="16">mdi-truck-delivery</v-icon>
              </v-avatar>
              <div>
                <h2 class="text-subtitle-1 font-weight-bold mb-1">Timeline BPB</h2>
                <p class="text-caption mb-0 white--text" style="opacity: 0.9;">{{ bpbData.length }} dokumen BPB</p>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-chip color="white" text-color="green" small class="font-weight-bold">
              <v-icon left x-small>mdi-truck-delivery</v-icon>
              {{ bpbData.length }}
            </v-chip>
          </v-card-title>
          
          <v-card-text class="pa-3">
            <div class="document-timeline-compact">
              <div 
                v-for="(item, index) in bpbData" 
                :key="index"
                class="document-item mb-2"
              >
                <v-card 
                  class="document-card-compact" 
                  elevation="1"
                  hover
                  :class="`document-card--${getStatusColor(item.status)}`"
                >
                  <v-card-text class="pa-3">
                    <v-row align="center" dense>
                      <!-- Document Icon & Type -->
                      <v-col cols="12" sm="7">
                        <div class="d-flex align-center">
                          <v-avatar :color="getStatusColor(item.status)" size="32" class="mr-2">
                            <v-icon color="white" size="16">{{ getDocumentIcon(item.document_type) }}</v-icon>
                          </v-avatar>
                          <!-- <div>
                            <h4 class="text-caption font-weight-bold mb-0">{{ item.document_type }}</h4>
                            <p class="text-caption grey--text mb-0">{{ formatDateShort(item.created_at) }}</p>
                          </div> -->
                          <div>
                            <h3 class="text-caption font-weight-bold mb-1 primary--text">
                              {{ item.document_number }}
                            </h3>
                            <p class="text-caption grey--text mb-0">{{ formatDateShort(item.created_at) }}</p>
                            <div class="text-caption grey--text text--darken-1" v-html="item.description"></div>
                          </div>
                        </div>
                      </v-col>
                      
                      
                      <!-- Status & Action -->
                      <v-col cols="12" sm="5">
                        <div class="d-flex flex-column">
                          <v-chip 
                            :color="getStatusColor(item.status)" 
                            dark 
                            small
                            class="font-weight-bold mb-2 text-capitalize status-chip-full justify-center"
                            label
                          >
                            {{ item.status }}
                          </v-chip>
                          <v-btn
                            :href="getDetailRoute(item)"
                            target="_blank"
                            color="primary"
                            outlined
                            x-small
                            class="text-caption text-capitalize align-self-end"
                          >
                            <v-icon left x-small>mdi-eye</v-icon>
                            Detail
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <!-- Compact Documents Timeline - Invoice -->
        <v-card v-if="!loading && invoiceData.length" class="mb-4" elevation="2">
          <v-card-title class="gradient-blue white--text pa-4">
            <div class="d-flex align-center">
              <v-avatar color="white" size="32" class="mr-3">
                <v-icon color="blue" size="16">mdi-receipt</v-icon>
              </v-avatar>
              <div>
                <h2 class="text-subtitle-1 font-weight-bold mb-1">Timeline Invoice</h2>
                <p class="text-caption mb-0 white--text" style="opacity: 0.9;">{{ invoiceData.length }} dokumen Invoice</p>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-chip color="white" text-color="blue" small class="font-weight-bold">
              <v-icon left x-small>mdi-receipt</v-icon>
              {{ invoiceData.length }}
            </v-chip>
          </v-card-title>
          
          <v-card-text class="pa-3">
            <div class="document-timeline-compact">
              <div 
                v-for="(item, index) in invoiceData" 
                :key="index"
                class="document-item"
              >
                <v-card 
                  class="document-card-compact" 
                  elevation="1"
                  hover
                  :class="`document-card--blue mb-2`"
                >
                  <v-card-text class="pa-3">
                                      <v-row align="center" dense>
                    <!-- Document Icon & Type -->
                    <v-col cols="12" sm="8">
                      <div class="d-flex align-center">
                        <v-avatar :color="'blue'" size="32" class="mr-2">
                          <v-icon color="white" size="16">{{ getDocumentIcon(item.document_type) }}</v-icon>
                        </v-avatar>
                        <div>
                          <div>
                            <h3 class="text-caption font-weight-bold mb-1 primary--text">
                              {{ item.document_number }}
                            </h3>
                            <p class="text-caption grey--text mb-0">{{ formatDateShort(item.created_at) }}</p>
                            <div class="text-caption grey--text text--darken-1" v-html="item.description"></div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    
                    <!-- Status & Action -->
                    <v-col cols="12" sm="4">
                      <div class="d-flex flex-column">
                        <v-chip 
                          :color="getStatusColor(item.status)" 
                          dark 
                          small
                          class="font-weight-bold mb-2 text-capitalize status-chip-full justify-center"
                          label
                        >
                          {{ item.status }}
                        </v-chip>
                        <v-btn
                          :href="getDetailRoute(item)"
                          target="_blank"
                          color="primary"
                          outlined
                          x-small
                          class="text-caption text-capitalize align-self-end"
                        >
                          <v-icon left x-small>mdi-eye</v-icon>
                          Detail
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  


    <!-- Empty State for Documents -->
    <v-card v-if="!loading && trackingData.length === 0 && orderInfo" class="mb-4" elevation="1">
      <v-card-text class="text-center pa-6">
        <v-icon size="60" color="grey lighten-1" class="mb-3">mdi-file-document-outline</v-icon>
        <h3 class="text-subtitle-1 font-weight-medium grey--text text--darken-1 mb-2">
          Belum Ada Dokumen
        </h3>
        <p class="text-body-2 grey--text">
          Belum ada dokumen BPB atau Invoice yang tersedia untuk order ini
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { get } from '@/service/Axios'

export default {
  components: {
    navbar: () => import(/* webpackPrefetch: true */ '@/components/navbar.vue')
  },
  
  data() {
    return {
      soNumber: '',
      loading: false,
      searched: false,
      trackingData: [],
      orderInfo: null,
      order_list: [],
      searchInput: '',
      searchTimeout: null,
      isInitialLoad: false,
      preventSearchLoop: false,
      process: {
        load: false,
        search: false
      }
    }
  },

  computed: {
    rps () {
      return this.$vuetify.breakpoint.name
    },
    user () {
      return this.$store.state.user
    },
    fcm () {
      return this.$store.state.fcm
    },
    filter_order () {
      return this.$store.state.order
    },
    isDay () {
      let hours = (new Date()).getHours(),
          day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
      return day
    },
    set_color () {
      return this.$store.state.color
    },
    set_color_rgb () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g}, ${b}, 0.97)`
    },
    set_color_rgb_up () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
    },
    set_color_rgb_down () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g}, ${b}, 0.25)`
    },

    configHeaders () {
      return this.headers.filter(header => !header.hide)  
    },

    years () {
      let max = new Date().getFullYear()+2, min = max - 2, years = []

      for (let i = max; i >= min; i--) {
        years.push({
          text: i,
          value: i
        })
      }

      return years
    },
    summaryStats() {
      if (!this.trackingData.length) return []
      
      const bpbCount = this.trackingData.filter(item => item.document_type === 'BPB').length
      const invoiceCount = this.trackingData.filter(item => item.document_type === 'Invoice').length
      const completedCount = this.trackingData.filter(item => 
        ['Belum Diproses', 'pengiriman terkonfirmasi', 'lunas', 'diterima'].includes(item.status.toLowerCase())
      ).length
      const pendingCount = this.trackingData.filter(item => 
        ['pending', 'belum lunas', 'dalam perjalanan'].includes(item.status.toLowerCase())
      ).length

      return [
        {
          label: 'Total Dokumen',
          count: this.trackingData.length,
          icon: 'mdi-file-multiple',
          color: 'primary'
        },
        {
          label: 'BPB',
          count: bpbCount,
          icon: 'mdi-truck-delivery',
          color: 'green'
        },
        {
          label: 'Invoice',
          count: invoiceCount,
          icon: 'mdi-receipt',
          color: 'blue'
        },
        {
          label: 'Selesai',
          count: completedCount,
          icon: 'mdi-check-circle',
          color: 'success'
        }
      ]
    },

    sortedTrackingData() {
      return [...this.trackingData].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },

    bpbData() {
      return this.trackingData.filter(item => item.document_type === 'BPB')
    },

    invoiceData() {
      return this.trackingData.filter(item => item.document_type === 'Invoice')
    }
  },

  created() {
    // Set page title
    document.title = 'Tracking Order | Mitra Warung'

    // Check if SO number is provided in query params
    if (this.$route.query.number) {
      this.isInitialLoad = true
      this.preventSearchLoop = true
      this.soNumber = this.$route.query.number
      this.searchInput = this.$route.query.number
      this.$nextTick(() => {
        this.searchTracking()
        this.preventSearchLoop = false
      })
    } else {
      // Only fetch empty orders if no query number
      this.fetchOrder('')
    }
  },

  mounted() {
    this.fetchOrder('')
  },

  beforeDestroy() {
    // Clear timeout when component is destroyed
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },

  methods: {
    handleOrderChange() {
      // Only trigger search when user selects from dropdown
      if (this.soNumber && !this.preventSearchLoop) {
        this.searchTracking()
      }
    },

    onSearchInput(searchTerm) {
      // Skip if we're preventing search loop or during initial load
      if (this.preventSearchLoop || this.isInitialLoad) {
        return
      }

      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      // Prevent loop if searchTerm is same as current soNumber
      if (searchTerm === this.soNumber && this.trackingData.length > 0) {
        return
      }

      // Set new timeout for debounced search
      this.searchTimeout = setTimeout(() => {
        if (searchTerm && searchTerm.length >= 2) {
          this.fetchOrder(searchTerm)
        } else if (searchTerm === '' || !searchTerm) {
          // Reset data when search is cleared
          this.clearFilter()
        }
      }, 500) // 500ms delay
    },

    async fetchOrder (searchTerm = '') {
      // Prevent multiple simultaneous requests
      if (this.process.search) {
        return
      }

      this.process.search = true

      let params = {
        limit: 50,
        search: searchTerm,
        sort: '-id'
      }

      await get(`admin/order/data`, { params })
      .then(response => {
        let res = response.data
          
        if (res.status === 200) {
          this.order_list = res.results.data
        }
        this.process.search = false
      })
      .catch(error => {
        console.error('Error fetching orders:', error)
        this.process.search = false
      })
    },
    async searchTracking() {
      if (!this.soNumber) {
        this.$notify({
          type: 'warning',
          title: 'Perhatian',
          text: 'Harap masukkan nomor SO terlebih dahulu'
        })
        return
      }

      this.loading = true
      this.searched = true
      
      // Update URL query parameter
      // this.$router.replace({ 
      //   query: { ...this.$route.query, number: this.soNumber }
      // })

      let params = {
        number: this.soNumber
      }

      await get(`admin/order/tracking`, { params })
      .then(response => {
        let res = response.data
        
        this.loading = false
        this.isInitialLoad = false
        
        if (res.status === 200) {
          let orderData = res.results.data && res.results.data.length > 0 ? res.results.data[0] : null
          
          if (orderData) {
            // Combine BPB and Invoice data into tracking items
            this.trackingData = []
            this.orderInfo = orderData
            
            // Add BPB data
            if (orderData.bpb && orderData.bpb.length > 0) {
              orderData.bpb.forEach(bpb => {
                this.trackingData.push({
                  id: bpb.bpb_id,
                  document_type: 'BPB',
                  document_number: bpb.bpb_number,
                  status: bpb.delivery?.delivery_status || 'Belum Diproses',
                  created_at: bpb.bpb_input_datetime,
                  description: bpb.delivery 
                    ? `Surat Jalan: <a href="/delivery/surat-jalan/detail/${bpb.delivery.delivery_id}" target="_blank" style="color: #1976d2; text-decoration: none;">${bpb.delivery.delivery_number}</a>`
                    : 'Surat Jalan: -',
                  delivery_id: bpb.delivery?.delivery_id
                })
              })
            }
            
            // Add Invoice data
            if (orderData.invoice && orderData.invoice.length > 0) {
              orderData.invoice.forEach(invoice => {
                this.trackingData.push({
                  id: invoice.invoice_id,
                  document_type: 'Invoice',
                  document_number: invoice.invoice_number,
                  status: invoice.invoice_status,
                  created_at: invoice.invoice_input_datetime,
                  description: `Status: ${invoice.invoice_status}`
                })
              })
            }
            
            if (this.trackingData.length === 0) {
              this.$notify({
                type: 'info',
                title: 'Informasi',
                text: `Belum ada dokumen tracking untuk SO: ${this.soNumber}`
              })
            }
          } else {
            this.trackingData = []
            this.$notify({
              type: 'info',
              title: 'Informasi',
              text: `Tidak ada data ditemukan untuk SO: ${this.soNumber}`
            })
          }
        } else {
          this.trackingData = []
          this.$notify({
            type: 'error',
            title: 'Error',
            text: res.message || 'Gagal memuat data tracking'
          })
        }
      })
      .catch(error => {
        this.loading = false
        this.isInitialLoad = false
        console.error('Error fetching tracking data:', error)
        this.$notify({
          type: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Terjadi kesalahan saat memuat data tracking'
        })
        this.trackingData = []
      })

    },

    clearFilter() {
      this.preventSearchLoop = true
      this.soNumber = ''
      this.trackingData = []
      this.orderInfo = null
      this.searchInput = ''
      this.searched = false
      this.isInitialLoad = false
      
      // Clear any pending search timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }
      
      this.$nextTick(() => {
        // Fetch orders with empty search string
        this.fetchOrder('')
        this.preventSearchLoop = false
      })
    },

    getStatusColor(status) {
      const statusColors = {
        'pending': 'orange',
        'processing': 'blue',
        'completed': 'green',
        'cancelled': 'red',
        'approved': 'green',
        'rejected': 'red',
        'shipped': 'teal',
        'delivered': 'success',
        'diterima': 'green',
        'belum lunas': 'orange',
        'lunas': 'green',
        'pengiriman terkonfirmasi': 'success',
        'dalam perjalanan': 'blue',
        'terkirim': 'success'
      }
      return statusColors[status?.toLowerCase()] || 'grey'
    },

    getDetailRoute(item) {
      const documentType = item.document_type?.toLowerCase()
      const id = item.id
      
      // Route mapping for different document types
      const routeMapping = {
        'bpb': `/delivery/bpb/detail/${id}`,
        'invoice': `/finance/invoice/detail/${id}`,
        'surat jalan': item.delivery_id ? `/delivery/surat-jalan/detail/${item.delivery_id}` : `/delivery/surat-jalan/detail/${id}`,
        'delivery': item.delivery_id ? `/delivery/surat-jalan/detail/${item.delivery_id}` : `/delivery/surat-jalan/detail/${id}`
      }
      
      return routeMapping[documentType] || `/admin/approval-order/general-manager/${this.orderInfo?.id || id}`
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('id-ID', {
          day: '2-digit',
          month: '2-digit', 
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return dateString
      }
    },

    formatDateShort(dateString) {
      if (!dateString) return '-'
      
      try {
        const date = new Date(dateString)
        const days = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']
        const months = [
          'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
          'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ]
        
        const dayName = days[date.getDay()]
        const day = String(date.getDate()).padStart(2, '0')
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        
        return `${dayName}, ${day} ${month} ${year} ${hours}:${minutes}`
      } catch (error) {
        return dateString
      }
    },

    getDocumentIcon(documentType) {
      const iconMapping = {
        'BPB': 'mdi-truck-delivery',
        'Invoice': 'mdi-receipt',
        'Surat Jalan': 'mdi-file-document-outline',
        'Purchase Order': 'mdi-shopping',
        'Penerimaan': 'mdi-package-variant'
      }
      return iconMapping[documentType] || 'mdi-file-document'
    },

    getDeliveryStatus() {
      const bpb = this.trackingData.find(item => item.document_type === 'BPB')
      if (bpb) {
        const status = bpb.status.toLowerCase()
        if (status.includes('terkonfirmasi') || status.includes('diterima')) return 'Terkirim'
        if (status.includes('perjalanan')) return 'Dalam Perjalanan'
        return 'Pending'
      }
      return 'Belum ada'
    },

    getPaymentStatus() {
      const invoice = this.trackingData.find(item => item.document_type === 'Invoice')
      if (invoice) {
        const status = invoice.status.toLowerCase()
        if (status.includes('lunas')) return 'Lunas'
        if (status.includes('belum')) return 'Belum Lunas'
        return invoice.status
      }
      return 'Belum ada'
    },

    getLastDocumentType() {
      if (this.sortedTrackingData.length > 0) {
        return this.sortedTrackingData[0].document_type
      }
      return '-'
    },

    getOrderProgress() {
      if (!this.trackingData.length) return 0
      
      let progress = 20 // Start with order created
      
      const hasBPB = this.trackingData.some(item => item.document_type === 'BPB')
      const hasInvoice = this.trackingData.some(item => item.document_type === 'Invoice')
      const isDelivered = this.trackingData.some(item => 
        ['pengiriman terkonfirmasi', 'diterima', 'terkirim'].includes(item.status.toLowerCase())
      )
      const isPaid = this.trackingData.some(item => 
        item.status.toLowerCase().includes('lunas')
      )
      
      if (hasBPB) progress += 20
      if (hasInvoice) progress += 20
      if (isDelivered) progress += 20
      if (isPaid) progress += 20
      
      return progress
    }
  }
}
</script>

<style scoped>
/* Compact Layout */
.v-card {
  border-radius: 8px !important;
}

/* Compact Header */
.text-h6 {
  font-size: 1.1rem !important;
  line-height: 1.3;
}

/* Gradient Background */
.gradient-primary {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
}

.gradient-success {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%) !important;
}

.gradient-blue {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
}

/* Table Layout for Order Details */
table {
  border-collapse: collapse;
}

table td {
  padding: 2px 0;
  vertical-align: top;
}

table td:first-child {
  color: #666;
  min-width: 120px;
}

table td:last-child {
  color: #333;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-none:hover {
  text-decoration: underline !important;
}

/* Mini Statistics */
.stat-mini {
  padding: 8px;
  border-radius: 4px;
  background: rgba(25, 118, 210, 0.05);
  border: 1px solid rgba(25, 118, 210, 0.1);
}

/* Compact Document Cards */
.document-timeline-compact {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.document-item {
  margin-bottom: 0;
}

.document-card-compact {
  border-radius: 8px !important;
  border-left: 4px solid #ddd;
  transition: all 0.2s ease;
}

.document-card-compact:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

.document-card--green {
  border-left-color: #4caf50;
  background: linear-gradient(90deg, rgba(76, 175, 80, 0.03) 0%, #fff 15%);
}

.document-card--orange {
  border-left-color: #ff9800;
  background: linear-gradient(90deg, rgba(255, 152, 0, 0.03) 0%, #fff 15%);
}

.document-card--blue {
  border-left-color: #2196f3;
  background: linear-gradient(90deg, rgba(33, 150, 243, 0.03) 0%, #fff 15%);
}

.document-card--success {
  border-left-color: #4caf50;
  background: linear-gradient(90deg, rgba(76, 175, 80, 0.03) 0%, #fff 15%);
}

.document-card--teal {
  border-left-color: #009688;
  background: linear-gradient(90deg, rgba(0, 150, 136, 0.03) 0%, #fff 15%);
}

.document-card--grey {
  border-left-color: #9e9e9e;
  background: linear-gradient(90deg, rgba(158, 158, 158, 0.03) 0%, #fff 15%);
}

/* Additional Info */
.additional-info {
  padding: 8px;
  border-radius: 4px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  text-align: center;
}

/* Compact Typography */
.text-caption {
  font-size: 11px !important;
  line-height: 1.3;
}

.text-subtitle-1 {
  font-size: 14px !important;
  line-height: 1.3;
}

.text-subtitle-2 {
  font-size: 13px !important;
  line-height: 1.3;
}

/* Compact Buttons */
.v-btn {
  border-radius: 6px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.25px;
}

.v-btn--x-small {
  height: 24px !important;
  font-size: 10px !important;
  padding: 0 8px !important;
}

/* Compact Chips */
.v-chip {
  border-radius: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0.25px;
}

.v-chip--x-small {
  height: 20px !important;
  font-size: 10px !important;
  padding: 0 6px;
}

.v-chip--small {
  height: 24px !important;
  font-size: 11px !important;
  padding: 0 8px;
}

/* Status Chip Full Width */
.status-chip-full {
  max-width: 100% !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  line-height: 1.2 !important;
  height: auto !important;
  min-height: 24px !important;
  padding: 4px 8px !important;
}

.status-chip-full .v-chip__content {
  white-space: normal !important;
  word-wrap: break-word !important;
}

/* Compact Progress */
.v-progress-linear {
  border-radius: 3px !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .pa-3 {
    padding: 12px !important;
  }
  
  .pa-4 {
    padding: 16px !important;
  }
  
  .document-card-compact:hover {
    transform: none;
  }
}

/* Dense Spacing */
.v-card + .v-card {
  margin-top: 0 !important;
}

/* Smooth Transitions */
* {
  transition: all 0.2s ease;
}
</style>
